<template>
  <div class="field">
    <label :for="id">{{ label }}</label>
    <input
      :id="id"
      :value="modelValue"
      :name="id"
      :type="type"
      :autocomplete="autocomplete"
      :aria-invalid="!!error"
      :aria-describedby="error ? `${id}-error` : undefined"
      @input="
        $emit('update:modelValue', ($event.target as HTMLInputElement).value)
      "
    />
    <p v-if="error" :id="`${id}-error`" class="error">{{ error }}</p>
  </div>
</template>
<script setup lang="ts">
withDefaults(
  defineProps<{
    id: string;
    modelValue: string;
    label: string;
    type?: string;
    autocomplete?: string;
    error?: string;
  }>(),
  { type: "text", autocomplete: "", error: "" }
);
defineEmits<{ (event: "update:modelValue", value: string): void }>();
</script>
<style scoped>
.field {
  margin-bottom: 1rem;
}
label {
  display: block;
  font-weight: 650;
  margin-bottom: 0.4rem;
}
input {
  box-sizing: border-box;
  width: 100%;
  min-height: 44px;
  padding: 0.75rem;
  border: 1px solid #717b8d;
  border-radius: 0.3rem;
}
input:focus-visible {
  outline: 3px solid #ee7203;
  outline-offset: 2px;
}
.error {
  color: #9d1c13;
  margin: 0.35rem 0 0;
}
</style>
